import request from '@/plugins/request';
import { IBoolResult } from '@/types/dto';
import { MessageType } from '@/types/enums';
import { ITicketMessage, ITicket, IUser, IHost, ITheme, IExtension, ICloud } from '@/types/models';
import utils from '@/utils';
import { AxiosResponse } from 'axios';
import { API_URL } from '@/const';

const $url = '/admin/ticketMessages';
const $urlClose = '/admin/ticketMessages/actions/close';
const $urlOpen = '/admin/ticketMessages/actions/open';
const $urlUpload = '/admin/ticketMessages/actions/upload';
const $urlResources = '/admin/ticketMessages/actions/resources';

export interface IGetRequest {
  ticketNo: string;
}

export interface IGetResult {
  ticket: ITicket;
  user: IUser;
  count: number;
  messages: ITicketMessage[];
}

export interface ISubmitRequest {
  ticketNo: string;
  messageType: MessageType;
  storageKey: string;
  content: string;
}

export interface ISubmitResult {
  message: ITicketMessage;
}

export interface IDeleteRequest {
  messageId: number;
}

export interface ICloseRequest {
  ticketNo: string;
}

export interface IOpenRequest {
  ticketNo: string;
}

export interface IUploadResult {
  messageType: MessageType;
  storageKey: string;
  content: string;
}

interface IResourcesResult {
  hosts: IHost[];
  cloud: ICloud;
  themes: ITheme[];
  extensions: IExtension[];
}

export default {
  get(req: IGetRequest, success: (res: IGetResult) => void) {
    utils.loading(true);
    request
      .get($url, {
        params: req,
      })
      .then((response: AxiosResponse<IGetResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  delete(req: IDeleteRequest, success: (res: IBoolResult) => void) {
    utils.loading(true);
    request
      .delete($url, {
        data: req,
      })
      .then((response: AxiosResponse<IBoolResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  submit(req: ISubmitRequest, success: (res: ISubmitResult) => void) {
    utils.loading(true);
    request
      .post($url, req)
      .then((response: AxiosResponse<ISubmitResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  close(req: ICloseRequest, success: (res: IBoolResult) => void) {
    request
      .post($urlClose, req)
      .then((response: AxiosResponse<IBoolResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      });
  },

  open(req: IOpenRequest, success: (res: IBoolResult) => void) {
    request
      .post($urlOpen, req)
      .then((response: AxiosResponse<IBoolResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      });
  },

  resources(userId: number, success: (res: IResourcesResult) => void) {
    utils.loading(true);
    request
      .post($urlResources, {
        userId,
      })
      .then((response: AxiosResponse<IResourcesResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  getUploadUrl() {
    return API_URL + $urlUpload;
  },
};
